module.exports = __webpack_public_path__ + "img/benin.fd165c86.svg";